import { Injectable, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ExperimentStatusIsPipe } from '../pipes/experiment-status-is.pipe';
import { HasAnyRolesPipe } from '../pipes/has-any-roles.pipe';
import { Experiment, StudyType } from '../services/labpartner.service.model';
import { BaseComponent } from './base.component';

@Injectable()
export class SamplesConditionsBase extends BaseComponent {
  @Input() currentExperiment: Experiment | null = null;
  @Input() currentRoles: string[] = [];

  listData!: MatTableDataSource<any>;

  constructor(
    protected hasAnyRolesPipe: HasAnyRolesPipe,
    protected statusIsPipe: ExperimentStatusIsPipe,
  ) {
    super();
  }

  protected ngOnDestroyInternal(): void {
    throw new Error('Method not implemented.');
  }

  // Function to determine if the edit button should be disabled
  isEditButtonDisabled() {
    // Disable the edit button if the current role is not WRITER
    return !this.hasAnyRolesPipe.transform(
      this.currentRoles,
      ['WRITER'],
      this.currentExperiment,
      'IsAnyStatus',
    );
  }

  // Function to determine if the edit button should be displayed
  isEditButtonDisplayed() {
    const studyType = this.currentExperiment?.studyType;

    if (studyType == null || studyType == StudyType.ImportExcel) {
      // If the study type is ImportExcel, the edit button should be shown if the experiment is ready to test
      return this.statusIsPipe.transform(this.currentExperiment, ['ReadyToTest']) && this.listData;
    } else {
      // If the study type is not ImportExcel, the edit button should be shown if the experiment is not complete
      return !this.statusIsPipe.transform(this.currentExperiment, ['Complete']) && this.listData;
    }
  }
}
